module.exports = __webpack_public_path__ + "static/media/image010.06e09c13.jpg";